import { Line } from 'react-chartjs-2'
import type { TrendPoint } from '@/api/types'

export function TrendLine({ points }: { points: TrendPoint[] }) {
  const labels = points.map((p) => new Date(p.taken_at).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  }))
  const data = {
    labels,
    datasets: [
      {
        label: 'Critical',
        data: points.map((p) => p.critical),
        borderColor: '#C22221',
        backgroundColor: 'rgba(194,34,33,0.1)',
        tension: 0.3,
      },
      {
        label: 'High',
        data: points.map((p) => p.high),
        borderColor: '#eab308',
        backgroundColor: 'rgba(234,179,8,0.1)',
        tension: 0.3,
      },
      {
        label: 'Trend (EWMA)',
        data: points.map((p) => p.ewma_critical_high),
        borderColor: '#254F71',
        borderDash: [5, 4],
        tension: 0.3,
      },
    ],
  }
  return (
    <Line
      data={data}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { labels: { boxWidth: 12, font: { size: 11 } } },
          tooltip: {
            callbacks: {
              // Explain the dashed EWMA line on hover; other series show only their value.
              afterLabel: (ctx) =>
                ctx.dataset.label === 'Trend (EWMA)'
                  ? 'Smoothed trend (α=0.3): recent days weighted more; filters daily noise'
                  : '',
            },
          },
        },
        scales: { y: { beginAtZero: true } },
      }}
    />
  )
}
